module.exports = __webpack_public_path__ + "static/media/08.59d9ef02.jpg";